import React, { useState, useEffect, useRef } from 'react'
import { Bookmark, X } from 'lucide-react'
import styles from './SavedFiltersButton.module.css'
import { useToolFilterPresetsStore } from '../../../store/toolFilterPresetsStore'
import { useToolsListViewStore } from '../../../store/toolsListViewStore'

const SavedFiltersButton: React.FC = () => {
    const { loadPresets, addPreset } = useToolFilterPresetsStore()
    const store = useToolsListViewStore()

    const [open, setOpen] = useState(false)
    const [saveMode, setSaveMode] = useState(false)
    const [saveName, setSaveName] = useState('')

    const wrapperRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        loadPresets()
    }, [loadPresets])

    useEffect(() => {
        if (!open) return
        const handleClick = (e: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
                setOpen(false)
                setSaveMode(false)
            }
        }
        document.addEventListener('mousedown', handleClick)
        return () => document.removeEventListener('mousedown', handleClick)
    }, [open])

    const currentFilters = {
        statusFilter: store.statusFilter,
        methodFilter: store.methodFilter,
        environmentFilter: store.environmentFilter,
        connectionFilter: store.connectionFilter,
        selectedTags: store.selectedTags,
        sortBy: store.sortBy,
        searchTerm: store.searchTerm,
    }

    const handleSave = async () => {
        const name = saveName.trim()
        if (!name) return
        await addPreset(name, currentFilters)
        setSaveName('')
        setSaveMode(false)
        setOpen(false)
    }

    return (
        <div className={styles.wrapper} ref={wrapperRef}>
                <div className={styles.dropdown}>
                    <div>
                        {!saveMode ? (
                            <button
                                type="button"
                                className={styles.saveTrigger}
                                onClick={() => setSaveMode(true)}
                            >
                                <Bookmark size={13} />
                                Save current filters
                            </button>
                        ) : (
                            <div className={styles.saveForm}>
                                <input
                                    autoFocus
                                    className={styles.saveInput}
                                    placeholder="Preset name…"
                                    value={saveName}
                                    onChange={e => setSaveName(e.target.value)}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter') handleSave()
                                        if (e.key === 'Escape') { setSaveMode(false); setSaveName('') }
                                    }}
                                />
                                <button type="button" className={styles.saveConfirmBtn} onClick={handleSave}>Save</button>
                                <button type="button" className={styles.cancelBtn} onClick={() => { setSaveMode(false); setSaveName('') }}>
                                    <X size={13} />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
        </div>
    )
}

export default SavedFiltersButton
